<template>
  <IQOS :readonly="false">
    <template v-slot:header>{{ $t('workers.workers_queue.title') + ' - Telegram' }}</template>
    <!-- <h3 class="c-white">
      <img src="/icons/telegram.svg" class="telegram-logo" /> Telegram
    </h3> -->
    <!-- <p class="c-white comment pt-0">{{ $t('workers.notifications.pt0') }}</p> -->
    <div class="tg-guide c-white mb-0 pt-0">
      <p class="title">
        {{ $t('workers.notifications.pt1') }}
        <a href="https://t.me/QRWaiterBot" class="c-green">@QRWaiterBot</a>
      </p>
      <p class="title">{{ $t('workers.notifications.pt2') }} <a href="#" class="c-green">/cafe</a></p>
      <p class="title">
        {{ $t('workers.notifications.pt3') }}
        <b class="c-green">{{cafe.qId}}</b>
      </p>
      <p class="title mb-0">{{ $t('workers.notifications.pt4') }}</p>
    </div>
    <p
      class="c-grey comment"
    >{{ $t('workers.notifications.about') }}</p>
    <p class="c-white comment" v-if="chat_users_count">
      {{ $t('workers.notifications.users_count', {
        n: chat_users_count
      }) }}
    </p>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import TelegramAPI from "@/api/telegram"

export default {
  components: {
    IQOS
  },
  data() {
    return {
      chat_users_count: null
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    }
  },
  mounted() {
    TelegramAPI.getCafebotMembersCount(this.cafe._id).then(data => {
      this.chat_users_count = data.count;
    }).catch(err => console.error(err));
  }
};
</script>

<style scoped>
.telegram-logo {
  width: auto;
  height: 1.5vh;
  margin-top: -0.5vh;
  display: inline-block;
}

h3 {
  font-size: 2.3vh;
}

.tg-guide {
  /* margin-top: 1vh; */
}

p.comment {
    padding-top: 2.2vh;
}

.tg-guide p {
  /* font-size: 1.7vh; */
  margin: 0;
}
</style>